import React from 'react';
import { createPortal } from 'react-dom';
import { Document } from '@contentful/rich-text-types';
import Modal from '@jbhi-fi/lanyard-ui/components/Modal';
import { PerksContainer } from '../PerksContainer';
import { RichText } from '../RichText';
import { styles } from './TermsAndConditionsModal.css';

export type TermsAndConditionsSymbol = '*' | '#' | '~' | '^' | '†' | '°' | '◊' | '‡' | 'θ';

export type TermsAndConditionsData = {
  mainBody?: Document;
  symbol?: TermsAndConditionsSymbol;
  linkColor?: 'black' | 'white';
};

export type BannerWithTermsAndConditions = {
  termsAndConditions?: TermsAndConditionsData;
};

export type TermsAndConditionsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  mainBody?: Document;
};

export const TermsAndConditionsModal = ({ isOpen, onClose, mainBody }: TermsAndConditionsModalProps) => {
  const displayContent = mainBody ? <RichText document={mainBody} /> : <p>Terms & Conditions</p>;
  const portalTarget = typeof document !== 'undefined' ? document.body : null;

  if (!portalTarget) {
    return null;
  }

  return createPortal(
    <Modal
      show={isOpen}
      onClose={onClose}
      showFrame={false}
      frame={PerksContainer}
      customClass={styles.modal}
      zIndex={999999}
    >
      <div className={styles.container}>
        <h2 className={styles.heading}>Terms and conditions</h2>
        <div className={styles.content}>{displayContent}</div>
      </div>
    </Modal>,
    portalTarget
  );
};
